import { PayrollContributionRate } from '~/graphql/schema';

export type PayrollContributionRateType = PayrollContributionRate['__typename'];

export const PayrollContributionPercentType = 'PayrollContributionPercent' as const;
export const PayrollContributionAmountType = 'PayrollContributionAmount' as const;
